import React from 'react';
import { TrackingContext } from "../hooks/useTracking/useTracking";
import { NavigationDrilldownDrawer } from "./NavigationDrilldownDrawer";
export var NavigationDrilldown = function NavigationDrilldown(_ref) {
  var navigation = _ref.navigation,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(TrackingContext.Provider, {
    value: {
      navigationData: navigation
    }
  }, /*#__PURE__*/React.createElement(NavigationDrilldownDrawer, {
    navigation: navigation,
    onClose: onClose
  }));
};